export default [
  'BOTMyAppointmentsDetailsMyGarage',
  'BOTMyVehicleAppointmentsDetails'
]

/* Appears on My Garage page /my-account/vehicles */
/* Appears on My Garage page /my-account/vehicle-details */
